// npm/react
import d3 = require("d3");
import React = require("react");
import ReactFauxDOM = require("react-faux-dom");
import {Loader} from "../../../components/Utils/loader/Loader";
// local
import {WidgetResponse} from "../../DashboardContainer";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {FormatLocaleNumber} from "../DashboardUtils";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations

interface WeeksSaleeCompareWidgetProps {
    data: WidgetResponse;
    title: string;
}

interface WeeksSaleeCompareWidgetState {
    response: any;
}

interface WeekSalesCompareWidgetResponse {
    labels: object;
    sales: WeekSalesItem[][];
}

interface WeekSalesItem {
    id: string;
    order: number;
    sectorNameStr: string;
    value: number;
}

export class WeeksSalesCompareWidget extends React.Component<WeeksSaleeCompareWidgetProps, WeeksSaleeCompareWidgetState> {

    public static maxFromData(data): number {
        let max = null;
        for (const elem of data) {
            if (max == null || elem.value > max) {
                max = elem.value;
            }
        }
        return max;
    }

    constructor(props: WeeksSaleeCompareWidgetProps) {
        super(props);

        this.state = {
            response: undefined,
        };

        this.retrieveData();
    }

    public render() {
        if (!this.state.response) {
            return <div className="weeks-sales-compare-widget"><Loader/></div>;
        }
        const max0 = WeeksSalesCompareWidget.maxFromData(this.state.response.sales[0]);
        const max1 = WeeksSalesCompareWidget.maxFromData(this.state.response.sales[1]);
        const totalMax = Math.max(max0, max1);

        return (
            <VeBoxCard className="weeks-sales-compare-widget home-dashboard-card">
                <VeBoxCard.Header
                    title={this.props.title.toUpperCase()}
                    titleClassName={"lowercase capitalize"}
                    className="weeks-sales-compare-widget__header space-between"
                    back={
                        <div className={"badge horizontal-padding-10 commercial-badge"}>
                            <div className={"div-icon-20"}>
                                <div className={"div-icon-20"}>
                                    <img
                                        className={"icon-20"}
                                        src={"/vebox/images/misc/ic_person_man_boss.png"}
                                    />
                                </div>
                            </div>
                            <p className={"font-size-10 capitalize"}>{AppTranslations.dashboard.commercial}</p>
                        </div>
                    }
                />
                <AutoSizer style={{height: "100%"}}>
                    {({width, height}) =>
                        <VeBoxCard.Body className="weeks-sales-compare-widget__container">
                            <table className="charts-table">
                                <tbody>
                                <tr>
                                    <td>
                                        <WeeksSalesChart
                                            containerSize={{width, height}}
                                            label={this.state.response.labels.previousWeek}
                                            data={this.state.response.sales[0]}
                                            max={totalMax}
                                        />

                                    </td>
                                    <td>
                                        <WeeksSalesChart
                                            containerSize={{width, height}}
                                            label={this.state.response.labels.currentWeek}
                                            data={this.state.response.sales[1]}
                                            max={totalMax}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </VeBoxCard.Body>}
                </AutoSizer>
            </VeBoxCard>
        );
    }

    private retrieveData(): void {

        const dataUrl: string = this.props.data.dataUrl;
        Ajax.vbxAjax({
            url: dataUrl,
            type: "GET",
            cache: false,
            success: (response: WeekSalesCompareWidgetResponse) => {
                if (response) {
                    this.setState({
                        response,
                    });
                }
            },
        });
    }
}

interface WeeksSalesChartProps {
    containerSize: SizeMeObject;
    label: string;
    data: WeekSalesItem[];
    max: number;
}

interface SizeMeObject {
    width: number;
    height: number;
}

interface WeeksSalesChartState {

}

class WeeksSalesChart extends React.Component<WeeksSalesChartProps, WeeksSalesChartState> {

    public selector_colors = ["#FD9A32", "#98A8F3", "#FFCBFF", "#E7E2DF", "#FFCB99", "#68FE9B", "#FEFF99"];

    public innerRadius = 0;
    public outerRadius = 0;
    public radius = 0;
    public referenceMaxDomainValue = 0;
    public total = 0;

    constructor(props: WeeksSalesChartProps) {
        super(props);
    }

    public render() {
        return this.renderGraph();
    }

    public renderGraph() {
        let width = null;
        if (this.props.containerSize.width / 2 > this.props.containerSize.height) {
            width = Math.min(this.props.containerSize.width, this.props.containerSize.height);
        } else {
            width = this.props.containerSize.width / 2;
        }

        this.radius = width / 3;
        this.innerRadius = width / 10;
        this.referenceMaxDomainValue = this.props.max;
        this.total = 0;
        for (const elem of this.props.data) {
            if (elem.value) {
                this.total += elem.value;
            }
        }

        const div = new ReactFauxDOM.Element("div");
        const margin = {
            top: 50,
        };
        const outlineArc = d3.arc()
            .innerRadius(this.innerRadius)
            .outerRadius(this.radius);
        const arc = d3.arc()
            .innerRadius(this.innerRadius)
            .outerRadius((d) => {
                return ((d as any).data.value === 0 || this.referenceMaxDomainValue === 0 ? this.innerRadius :
                        ((this.radius - this.innerRadius) * (d as any).data.value / this.referenceMaxDomainValue) + this.innerRadius
                );
            });

        const pie = d3.pie()
            .sort(null)
            .value(() => 1);

        const svg = d3.select(div)
            .append("svg")
            .attr("width", width)
            .attr("height", width - margin.top);

        const pieSvg = svg.append("g")
            .attr(
                "transform",
                "translate(" + 0 + "," + 0 + ")",
            );

        const chart = pieSvg.append("g")
            .attr("data-id", this.props.label)
            .attr("transform", "translate(" + (width / 2) + "," + ((width - 100) / 2) + ")");

        chart.selectAll(".outlineArc")
            .data(pie(this.props.data as any))
            .enter()
            .append("path")
            .attr("stroke", "gray")
            .attr("fill", "#f5f5f5")
            .attr("class", "outlineArc")
            .attr("d", outlineArc as any);

        chart.selectAll(".solidArc")
            .data(pie(this.props.data as any))
            .enter()
            .append("path")
            .attr("fill", (d, i) => {
                return this.selector_colors[i];
            })
            .attr("class", "solidArc")
            .attr("d", arc as any)
            .on("mouseover", (event, d) => {
                this.showTooltip(d);
            })
            .on("mouseout", () => {
                    this.hideTooltip();
                },
            );

        chart.append("text")
            .attr("class", "pie-with-total-and-sectors total")
            .attr("data-id", this.props.label + "TooltipValue")
            .attr("dy", ".25em")
            .text(this.total ? FormatLocaleNumber(this.total) : "N/D");

        this.createSectorsLabels(chart, pie);
        // footer
        svg.append("text")
            .attr("class", "pie-with-total-and-sectors footer-label")
            .attr("dy", ".35em")
            .attr("x", width / 2)
            .attr("y", width * 4 / 5)
            .text(this.props.label.toUpperCase());

        // TODO: tooltips are updating but not visible
        // TODO: footer visible but sometimes cutoff
        return div.toReact();
    }

    public showTooltip(d) {
        const elem = d3.select(`[data-id="${this.props.label}TooltipValue"]`);
        elem.text(FormatLocaleNumber(d.data.value));
        elem.style("fill", this.selector_colors[d.index]);
    }

    public hideTooltip() {
        const elem = d3.select(`[data-id="${this.props.label}TooltipValue"]`);
        elem.text(this.total ? FormatLocaleNumber(this.total) : "N/D");
        elem.style("fill", "darkgrey");
    }

    public createSectorsLabels(chart, pie) {
        const pieData = pie(this.props.data);
        const labelArc = d3.arc()
            .innerRadius(this.radius + 2)
            .outerRadius(this.radius + 2)
            .startAngle(function (d) {
                return d.startAngle;
            });

        chart.selectAll(".donutArcs")
            .data(pieData)
            .enter()
            .append("path")
            .attr("class", "donutArcs")
            .attr("d", labelArc)
            .each(function (d, i) {
                // Execute the flip of all sector labels that are between 90° and 230°.

                // Search pattern for everything between the start and the first capital L
                const firstArcSection = /(^.+?)L/;
                // Grab everything up to the first Line statement
                let newArc = d3.select(this).attr("d");
                // Replace all the comma's so that IE can handle it
                newArc = newArc.replace(/,/g, " ");

                // If the start angle lies beyond a quarter of a circle (90 degrees or pi/2)
                // flip the end and start position
                if ((d as any).startAngle > AngleConverter.degToRad(
                    90) && (d as any).startAngle < AngleConverter.degToRad(230)) {
                    const startLoc = /M(.*?)A/,		// Everything between the first capital M and first capital A
                        middleLoc = /A(.*?)0 0 1/,	// Everything between the first capital A and 0 0 1
                        endLoc = /0 0 1 (.*?)$/;	// Everything between the first 0 0 1 and the end of the string (denoted by $)
                    // Flip the direction of the arc by switching the start en end point (and sweep flag)
                    // of those elements that are below the horizontal line
                    const newStart = endLoc.exec(newArc)[1];
                    const newEnd = startLoc.exec(newArc)[1];
                    const middleSec = middleLoc.exec(newArc)[1];

                    // Build up the new arc notation, set the sweep-flag to 0
                    newArc = "M" + newStart + "A" + middleSec + "0 0 0 " + newEnd;
                }// if

                // Create a new invisible arc that the text can flow along
                chart.append("path")
                    .attr("class", "hiddenDonutArcs")
                    .attr("id", "donutArc" + i)
                    .attr("d", newArc)
                    .style("fill", "none");
            });

        // Append the label names on the outside
        chart.selectAll(".donutText")
            .data(pieData)
            .enter().append("text")
            .attr("class", "donutText")
            // Move the labels below the arcs for those slices with an end angle greater than 90 degrees
            .attr("dy", function (d, i) {
                return ((d as any).startAngle > AngleConverter.degToRad(90)
                && (d as any).startAngle < AngleConverter.degToRad(230) ? 11 : -4);
            })
            .append("textPath")
            .attr("startOffset", function (d, i) {
                return ((d as any).startAngle > AngleConverter.degToRad(90)
                && (d as any).startAngle < AngleConverter.degToRad(230) ? "18%" : "25%");
            })
            .style("text-anchor", "middle")
            .attr("xlink:href", function (d, i) {
                return "#donutArc" + i;
            })
            .text(function (d) {
                return (d as any).data.sectorNameStr;
            });
    }
}

class AngleConverter {
    /**
     *  Transform a percentage to degrees
     *
     * @param perc
     * @returns {number}
     */
    public static percToDeg(perc: number): number {
        return perc * 360;
    }

    /**
     *  transform degrees to radiant
     *
     * @param deg
     * @returns {number}
     */
    public static degToRad(deg: number): number {
        return deg * Math.PI / 180;
    }

    /**
     *  Transform percentage to radiant
     *
     * @param perc
     * @returns {number}
     */
    public static percToRad(perc: number): number {
        return AngleConverter.degToRad(AngleConverter.percToDeg(perc));
    }
}
